export default {
  ADMIN: 'admin',
  PUBLIC: 'public',
  CLIENT: 'client',
  FILES: 'files'
}
